import { render, staticRenderFns } from "./AllWebsiteGroups.vue?vue&type=template&id=c1a55142&"
import script from "./AllWebsiteGroups.vue?vue&type=script&lang=ts&"
export * from "./AllWebsiteGroups.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports